import styles from './ChartLegend.module.css';

export type ChartLegendItem = {
  label: string;
  /** CSS color value (token preferred, e.g. `var(--color-red)`). */
  color: string;
  /** Optional border — used for dark swatches (e.g. Extinct) on dark surfaces. */
  borderColor?: string;
  /** `swatch` (default square) or `line` (horizontal rule for line charts). */
  variant?: 'swatch' | 'line';
};

type ChartLegendProps = {
  /** Optional key heading — omit when Figma shows legend items only. */
  heading?: string;
  items: readonly ChartLegendItem[];
};

/**
 * Shared chart key for State (and similar) donut/bar/line charts.
 * Colours come from the caller; layout and swatch chrome stay identical.
 */
export function ChartLegend({ heading, items }: ChartLegendProps) {
  return (
    <div className={styles.root}>
      {heading ? <p className={styles.heading}>{heading}</p> : null}
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.label} className={styles.item}>
            <span
              className={
                item.variant === 'line' ? styles.lineSwatch : styles.swatch
              }
              aria-hidden
              style={{
                backgroundColor: item.color,
                border: item.borderColor
                  ? `1px solid ${item.borderColor}`
                  : undefined,
              }}
            />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
